import React from 'react';
import styled from 'styled-components';
import css from '@styled-system/css';
import { FiChevronLeft } from 'react-icons/fi';
import { useSelector } from 'react-redux';

export const CustomLeftArrowNew = ({ onClick }) => {
  const { theme } = useSelector((state) => state.theme);

  return (
    <LeftArrowBox theme={theme} onClick={onClick} className="custom-left-arrow">
      <Wrapper>
        {/* <Bg theme={theme}></Bg> */}
        <FiChevronLeft className="icon" />
      </Wrapper>
    </LeftArrowBox>
  );
};
const Wrapper = styled.div`
  position: relative;
  height: 100%;
  width: 100%;

  svg {
    transition-duration: 0.3s;
    transition-property: opacity;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    opacity: 0;
  }
`;

const Bg = styled.div`
  position: absolute;
  top: 49.6%;
  transform: translateY(-50%);
  left: 0;
  height: 102%;
  width: 50px;
  background: ${(props) =>
    props.theme === 'dark'
      ? 'linear-gradient(to right,  var(--dark-navy-blue) 15%, rgba(0, 15, 30, 0) 100%)'
      : 'linear-gradient(to right,  #f0f0f0 15%, rgba(0, 15, 30, 0) 100%)'};
  /* filter: blur(5px); */
`;
const LeftArrowBox = styled('span')((props) =>
  css({
    position: 'absolute !important',
    left: '-10px',
    top: '50%',
    transform: 'translateY(-50%)',
    // height: '100%',
    // backgroundColor: 'rgba(0,0,0,.6)',
    zIndex: 1,
    // display: 'flex',
    // color: 'var(--dark-navy-blue)',
    cursor: 'pointer',
    // opacity: 0,

    svg: {
      position: 'absolute',
      zIndex: 1,
      top: '50%',
      transform: 'translateY(-50%)',
      margin: 'auto',
      fontSize: 35,
      color: `${props.theme === 'light' ? '#222' : '#fff'}`,
      transition: '.3s',
      background: 'var(--dark-navy-blue)',
      borderRadius: '50%'
      // '&:hover': {
      //   color: `${props.theme === 'light' ? '#000F1E' : '#F0F0F0'}`
      // }
    }
  })
);
